const CAT_VALUE = 'liquid';

/**
 * è·åæ°´æ³¢å¾æ°æ®
 */
export function getLiquidData(percent: number) {
  return [{ percent, type: CAT_VALUE }];
}
